export default __webpack_public_path__ + "static/media/bundle.f82a123f.png";